// extracted by mini-css-extract-plugin
export default {"footer-wrapper":"ZyGe34exlK4noYuTBTHA","footer-text":"zcxMwQw3SjaGayav8EXk"};